import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Paper, Tooltip } from '@material-ui/core'
import { useConfirm } from 'material-ui-confirm'
import { DeleteOutlineOutlined as DeleteIcon, EditOutlined as EditIcon } from '@material-ui/icons'

import sponsorshipLevelSlice, {
  getSponsorshipLevels,
  deleteSponsorshipLevel
} from 'store/sponsorship-level'
import { renderCol } from 'utils/renderColumns'

import ActionBar from 'components/ActionBar'
import ViewHeader from 'components/ViewHeader'
import Loading from 'components/Loading'
import ResourceNotFound from 'components/ResourceNotFound'
import BasicTable from 'components/BasicTable'
import getTableOptions from 'utils/getTableOptions'
import { toast } from 'react-toastify'

const options = getTableOptions()

const tableHead = [
  'Category',
  'Level',
  {
    name: 'Actions',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => renderCol(value),
      customHeadLabelRender: (meta) => renderCol(meta.label)
    }
  }
]

const formatTableData = (sponsorshipLevels, handleEdit, handleDelete) =>
  sponsorshipLevels.map((sponsorshipLevel) => [
    sponsorshipLevel.category,
    sponsorshipLevel.categoryLevel,
    <>
      <Tooltip title="Edit">
        <EditIcon
          color="action"
          style={{ cursor: 'pointer' }}
          onClick={() => handleEdit(sponsorshipLevel.id)}
        />
      </Tooltip>
      <Tooltip title="Delete">
        <DeleteIcon
          color="action"
          style={{ marginLeft: 5, cursor: 'pointer' }}
          onClick={() => handleDelete(sponsorshipLevel.id)}
        />
      </Tooltip>
    </>
  ])

const SponsorshipLevelsListing = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const { user } = useSelector((state) => state.auth)
  const { sponsorshipLevels, inProgress, currentPage, pageSize, error } = useSelector(
    (state) => state.sponsorshipLevel
  )

  useEffect(() => {
    dispatch(getSponsorshipLevels(user?.conferenceId))
  }, [user?.conferenceId])

  useEffect(() => {
    if (error) {
      const message = error.message
      dispatch(sponsorshipLevelSlice.actions.setError(null))
      toast(message, {
        type: 'error',
        autoClose: 3000
      })
    }
  }, [error])

  const handleEdit = (id) => history.push(`${location.pathname}/edit/${id}`)

  const handleDelete = async (id) => {
    try {
      await confirm({
        title: 'Delete sponsorship level',
        description: 'Are you sure you want to delete this sponsorship level?'
      })
      dispatch(deleteSponsorshipLevel(id))
    } catch {
      // do nothing
    }
  }

  const DataListing = () =>
    sponsorshipLevels.length === 0 ? (
      <ResourceNotFound message="No sponsorship level available" />
    ) : (
      <Paper variant="outlined" style={{ marginTop: '20px' }}>
        <BasicTable
          data={formatTableData(sponsorshipLevels, handleEdit, handleDelete)}
          columns={tableHead}
          options={{
            ...options,
            onChangePage: (page) => dispatch(sponsorshipLevelSlice.actions.setCurrentPage(page)),
            onChangeRowsPerPage: (size) =>
              dispatch(sponsorshipLevelSlice.actions.setPageSize(size)),
            page: currentPage,
            rowsPerPage: pageSize
          }}
        />
      </Paper>
    )

  return (
    <>
      <ViewHeader title="Sponsorship Level">
        <ActionBar
          actionText="Add Sponsorship Level"
          onAction={() => history.push(`${location.pathname}/new`)}
        />
      </ViewHeader>

      {inProgress ? <Loading /> : <DataListing />}
    </>
  )
}

export default SponsorshipLevelsListing
